module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__large"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.$store.state.carData.general.KoeretoejArtNavn === 'Motorcykel') ? _c('i', {
    staticClass: "fal fa-motorcycle fa-fw"
  }) : _c('i', {
    staticClass: "fal fa-car fa-fw"
  }), _vm._v("\n                    Køretøjet\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Type",
      "value": _vm.$store.state.carData.general.KoeretoejArtNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Stelnummer",
      "value": _vm.$store.state.carData.general.StelNr
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Status",
      "value": _vm.$store.state.carData.general.Status
    }
  }, [_c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            d. " + _vm._s(_vm._f("moment")(_vm.$store.state.carData.general.StatusDato, 'D. MMMM YYYY')) + "\n                        ")])]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Indregistreret",
      "value": _vm._f("moment")(_vm.$store.state.carData.general.FoersteRegistreringDato, 'D. MMMM YYYY')
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.$store.state.searching && _vm.$store.state.carData.lookups !== null) ? _c('div', [_vm._v("\n                        Dette køretøj er blevet fremsøgt\n                        "), (!_vm.$store.state.loadingLookups && _vm.$store.state.carData.lookups !== null && _vm.$store.state.carData.lookups.count > 0) ? _c('b', [_vm._v("\n                            " + _vm._s(_vm.$store.state.carData.lookups.count) + " gange\n                        ")]) : _c('b', [_vm._v("\n                            1 gang\n                        ")]), _vm._v(" "), (_vm.$store.state.carData.lookups && _vm.$store.state.carData.lookups.count > 0) ? _c('span', [_vm._v("\n                            og senest d.\n                            "), _c('b', [_vm._v("\n                                " + _vm._s(_vm._f("moment")(_vm.$store.state.carData.lookups.latest, 'D. MMMM YYYY [kl.] HH:mm')) + "\n                            ")])]) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.match && !_vm.$store.state.loadingDmr && !_vm.$store.state.loadingInspection && !_vm.$store.state.loadingRegistry) ? _c('div', {
    staticClass: "checks"
  }, [(_vm.$store.state.carData.registry.LaaneDokumenter.length > 0 && !_vm.$store.state.carData.dmr.BilenErLeaset) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Der er restgæld i køretøjet\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.registry.LaaneDokumenter.length === 0 && !_vm.$store.state.carData.dmr.BilenErLeaset) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen restgæld i køretøjet\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.BilenErLeaset) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er leaset\n                                "), _c('br'), _vm._v("\n                                (" + _vm._s(_vm._f("moment")(_vm.$store.state.carData.general.LeasingGyldigFra, 'DD/MM/YYYY')) + "\n                                -\n                                " + _vm._s(_vm._f("moment")(_vm.$store.state.carData.general.LeasingGyldigTil, 'DD/MM/YYYY')) + ")\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.wanted !== null && _vm.$store.state.carData.wanted.PoliceWantedStatus === 1 || !_vm.$store.state.carData.wanted) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er ikke efterlyst\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.wanted !== null && _vm.$store.state.carData.wanted.PoliceWantedStatus === 0) ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er efterlyst\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection !== null && _vm.$store.state.carData.inspection.MistaenkeligtKmStand && _vm.$store.state.carData.inspection) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Mistænkelig km-stand\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection !== null && !_vm.$store.state.carData.inspection.MistaenkeligtKmStand && _vm.$store.state.carData.inspection) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen mistanke om km-fusk\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat === 'Godkendt') ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet bestod sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat === 'Betinget godkendt') ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                \"Betinget godkendt\" ved sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat === 'Middel') ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                \"Middel\" ved sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length > 0 && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Godkendt' && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Betinget godkendt' && _vm.$store.state.carData.inspection.Rapporter[0].Synsresultat !== 'Middel') ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Bestod ikke sidste syn\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.inspection && _vm.$store.state.carData.inspection.Rapporter.length === 0) ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Endnu ikke synet\n                            ")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.carData.inspection) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen synsdata\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Status !== null && _vm.$store.state.carData.dmr.Forsikring.Status === 'Aktiv' && _vm.$store.state.carData.general.Status !== 'Afmeldt') ? _c('div', {
    staticClass: "single-check good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er forsikret\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Status !== null && _vm.$store.state.carData.dmr.Forsikring.Status !== 'Aktiv' && _vm.$store.state.carData.general.Status !== 'Afmeldt') ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er ikke forsikret\n                            ")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.carData.dmr.Forsikring.Status) ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Ingen forsikringsoplysninger\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Selskab === 'SELVFORSIKRING') ? _c('div', {
    staticClass: "single-check bad"
  }, [_c('i', {
    staticClass: "fal fa-exclamation fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Muligvis en civil politibil\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.general.Status && _vm.$store.state.carData.general.Status === 'Afmeldt') ? _c('div', {
    staticClass: "single-check neutral"
  }, [_c('i', {
    staticClass: "fal fa-info fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("\n                                Køretøjet er afmeldt\n                            ")])]) : _vm._e()]) : _c('data-loader', {
    attrs: {
      "title": "Henter data"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__third"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-1s"
  }, [_vm._m(1), _vm._v(" "), (!_vm.$store.state.loadingInspection && !_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.carData.dmr.SidsteSyn) ? _c('line-data', {
    attrs: {
      "title": "Sidste syn",
      "value": _vm._f("moment")(_vm.$store.state.carData.dmr.SidsteSyn, 'D. MMMM YYYY')
    }
  }) : _c('line-data', {
    attrs: {
      "title": "Sidste syn",
      "value": "Endnu ikke synet"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Næste syn om",
      "value": _vm.daysUntilNextInspection,
      "suffix": "dage"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "block-cta",
    attrs: {
      "tag": "div",
      "to": {
        name: 'SearchReports'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$scrollToTop($event)
      }
    }
  }, [_vm._v("\n                        Se alle synsrapporter\n                        "), (_vm.$store.state.carData.inspection.Rapporter && _vm.$store.state.carData.inspection.Rapporter.length > 0) ? _c('span', [_vm._v("\n                            (" + _vm._s(_vm.$store.state.carData.inspection.Rapporter.length) + ")\n                        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1) : _c('data-loader', {
    attrs: {
      "title": "Henter data fra Trafikstyrelsen"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column__third"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-1s"
  }, [_vm._m(2), _vm._v(" "), (!_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "body"
  }, [(_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0) ? _c('div', [(_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig') ? _c('line-data', {
    attrs: {
      "title": "Halvårlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length === 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Halvårlig') ? _c('line-data', {
    attrs: {
      "title": "Halvårlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig') ? _c('line-data', {
    attrs: {
      "title": "Årlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length === 0 && _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed === 'Årlig') ? _c('line-data', {
    attrs: {
      "title": "Årlig afgift",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length - 1].Pris
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Næste afgift om",
      "value": _vm.daysUntilNextCharge,
      "suffix": "dage"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "block-cta",
    attrs: {
      "tag": "div",
      "to": {
        name: 'SearchCharges'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$scrollToTop($event)
      }
    }
  }, [_vm._v("\n                            Se alle opkrævede afgifter\n                            "), (_vm.$store.state.carData.dmr.Afgift && _vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1) : _c('div', [_vm._v("\n                        Ingen afgiftsoplysninger\n                    ")])]) : _c('data-loader', {
    attrs: {
      "title": "Henter data fra Motorregistret"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-1s"
  }, [_vm._m(3), _vm._v(" "), (!_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "body align-top"
  }, [(_vm.$store.state.carData.dmr.Forsikring.Status !== null) ? _c('div', [_c('b', {
    staticStyle: {
      "display": "block",
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.carData.dmr.Forsikring.Selskab))]), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring !== null && _vm.$store.state.carData.dmr.Forsikring.Status !== 'Aktiv') ? _c('line-data', {
    attrs: {
      "title": "Status",
      "value": _vm.$store.state.carData.dmr.Forsikring.Status
    }
  }) : _c('line-data', {
    attrs: {
      "title": "Oprettet",
      "value": _vm._f("moment")(_vm.insuranceDate, 'D. MMM. YYYY')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-cta",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (link)')
      }
    }
  }, [_vm._v("\n                            Beregn din forsikringspris\n                            "), _c('i', {
    staticClass: "fas fa-external-link"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.carData.dmr.Forsikring.Status === null) ? _c('div', [_vm._v("\n                        Ingen forsikringsoplysninger\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "block-cta",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (link)')
      }
    }
  }, [_vm._v("\n                            Beregn din forsikringspris\n                            "), _c('i', {
    staticClass: "fas fa-external-link"
  })])]) : _vm._e()]) : _c('data-loader', {
    attrs: {
      "title": "Henter data fra Motorregistret"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column__small mobile-partner animated fadeIn delay-1s",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (mobil billede)')
      }
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-2s"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('line-data', {
    attrs: {
      "title": "Brændstofforbrug",
      "value": _vm.$store.state.carData.general.MotorKmPerLiter,
      "suffix": "km/l"
    }
  }), _vm._v(" "), (_vm.$store.state.carData.general.DrivkraftTypeNavn === 'El') ? _c('line-data', {
    attrs: {
      "title": "Elektrisk forbrug",
      "value": _vm.$store.state.carData.general.MotorElektriskForbrug,
      "suffix": "Wh/km"
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Brændstof type",
      "value": _vm.$store.state.carData.general.DrivkraftTypeNavn
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Antal cylindre",
      "value": _vm.$store.state.carData.general.MotorCylinderAntal
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Slagvolumen",
      "value": _vm.$store.state.carData.general.MotorSlagVolumen,
      "suffix": "cm<sup>3</sup>"
    }
  }, [(_vm.$store.state.carData.general.MotorStoerrelse) ? _c('span', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_vm._v("\n                            (" + _vm._s(_vm.$store.state.carData.general.MotorStoerrelse) + "L)\n                        ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Hestekræfter",
      "value": _vm._f("rounded")(_vm.$store.state.carData.general.MotorStoersteEffekt * 1.3636363636),
      "suffix": "HK"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Max hastighed",
      "value": _vm.$store.state.carData.general.MaksimumHastighed,
      "suffix": "km/t"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "block-cta",
    attrs: {
      "tag": "div",
      "to": {
        name: 'SearchTechnicalInfo'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$scrollToTop($event)
      }
    }
  }, [_vm._v("\n                        Se alle tekniske specifikationer\n                        "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column column__medium"
  }, [_c('div', {
    staticClass: "block fullheight animated fadeIn delay-2s",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "economy-fields-toggle absolute"
  }, [(!_vm.showEconomyFields) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.showEconomyFields = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil"
  }), _vm._v("\n                        Beregn din økonomi\n                    ")]) : _vm._e()]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "body economy"
  }, [(!_vm.showEconomyFields) ? _c('div', [_c('div', {
    staticClass: "economy-fields-toggle mobile"
  }, [(!_vm.showEconomyFields) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.showEconomyFields = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil"
  }), _vm._v("\n                                Beregn din økonomi\n                            ")]) : _vm._e()]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Brændstof",
      "value": _vm._f("currency")(_vm.totalFuel),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Service & vedligeholdelse",
      "value": _vm._f("currency")(_vm.totalMaintenance),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Forsikring",
      "value": _vm._f("currency")(_vm.totalInsurance),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Afgift",
      "value": _vm._f("currency")(_vm.totalCharges),
      "suffix": "kr."
    }
  }), _vm._v(" "), (_vm.calculator.monthlyLoan > 0) ? _c('line-data', {
    attrs: {
      "title": "Afdrag på lån",
      "value": _vm._f("currency")(_vm.calculator.monthlyLoan),
      "suffix": "kr."
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    staticClass: "big-text",
    attrs: {
      "title": "Total pr. måned",
      "value": _vm._f("currency")(_vm.totalExpensePerMonth),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "opacity": ".5",
      "font-size": "12px"
    }
  }, [_vm._v("\n                            Beregningerne er baseret på den gennemsnitlige danskers kørselsvaner og udgifter sammenholdt med dette køretøjs data.\n                        ")])], 1) : _c('div', {
    staticClass: "budget"
  }, [_c('line-data', {
    attrs: {
      "title": "Km kørt pr. år",
      "value": "donotshow",
      "alignCenter": true,
      "type": "km"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.kmPerYear),
      expression: "calculator.kmPerYear"
    }],
    staticClass: "form-control type-km",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "100000",
      "step": "1000",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.kmPerYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "kmPerYear", $event.target.value)
      }
    },
    slot: "extra"
  })]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Service & vedl. pr. km (kr.)",
      "value": "donotshow",
      "alignCenter": true,
      "type": "kr"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.maintenancePerKm),
      expression: "calculator.maintenancePerKm"
    }],
    staticClass: "form-control",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "1",
      "step": "0.10",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.maintenancePerKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "maintenancePerKm", $event.target.value)
      }
    },
    slot: "extra"
  })]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Årlig forsikring (kr.)",
      "value": "donotshow",
      "alignCenter": true,
      "type": "kr"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.insurance),
      expression: "calculator.insurance"
    }],
    staticClass: "form-control",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "100000",
      "step": "1000",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.insurance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "insurance", $event.target.value)
      }
    },
    slot: "extra"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "newline"
    },
    slot: "newline"
  }, [_c('a', {
    staticClass: "block-cta",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (Økonomi link)')
      }
    }
  }, [_vm._v("\n                                    Beregn din forsikringspris\n                                    "), _c('i', {
    staticClass: "fas fa-external-link"
  })])])]), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Afdrag på lån pr. måned (kr.)",
      "value": "donotshow",
      "alignCenter": true,
      "type": "kr"
    }
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.monthlyLoan),
      expression: "calculator.monthlyLoan"
    }],
    staticClass: "form-control",
    attrs: {
      "slot": "extra",
      "type": "number",
      "min": "0",
      "max": "30000",
      "step": "500",
      "inputmode": "numeric",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": (_vm.calculator.monthlyLoan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "monthlyLoan", $event.target.value)
      }
    },
    slot: "extra"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "newline"
    },
    slot: "newline"
  }, [_c('a', {
    staticClass: "block-cta",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goToLoanPartner('Økonomi link')
      }
    }
  }, [(_vm.$store.state.carData.general.KoeretoejArtNavn === 'Motorcykel') ? _c('span', [_vm._v("\n                                        Beregn dit MC-lån\n                                        "), _c('i', {
    staticClass: "fas fa-external-link"
  })]) : _c('span', [_vm._v("\n                                        Beregn dit billån\n                                        "), _c('i', {
    staticClass: "fas fa-external-link"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "economy-fields-toggle",
    on: {
      "click": function($event) {
        _vm.showEconomyFields = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("\n                            Gem og vis resultat\n                        ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-clipboard-check fa-fw"
  }), _vm._v("\n                    Tjekliste\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list-check fa-fw"
  }), _vm._v("\n                    Syn\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-envelope-open-dollar fa-fw"
  }), _vm._v("\n                    Afgift\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-file-certificate fa-fw"
  }), _vm._v("\n                    Forsikring\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/partners/samlino-500x500.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-cog fa-fw"
  }), _vm._v("\n                    Motor\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-sack-dollar fa-fw"
  }), _vm._v("\n                    Økonomi\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6a8fc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/pages/overview.vue
// module id = 352
// module chunks = 1